/**
 * Mobile: tap marker → fixed-center popup with backdrop overlay.
 * Desktop: hover/focus handled in CSS.
 */
(function () {
  var mq = window.matchMedia('(min-width: 990px)');

  function getBackdrop(root) {
    var section = root.closest('.store-map-locations');
    return section ? section.querySelector('[data-store-map-backdrop]') : null;
  }

  function hideBackdrop() {
    document.querySelectorAll('[data-store-map-backdrop].is-visible').forEach(function (el) {
      el.classList.remove('is-visible');
    });
    document.body.style.overflow = '';
  }

  function showBackdrop(root) {
    var backdrop = getBackdrop(root);
    if (backdrop) backdrop.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }

  function closeAll(root) {
    root.querySelectorAll('.store-map-locations__marker-wrap.is-open').forEach(function (wrap) {
      wrap.classList.remove('is-open');
      var btn = wrap.querySelector('.store-map-locations__marker');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  function closeAllSections() {
    document.querySelectorAll('[data-store-map-locations]').forEach(closeAll);
    hideBackdrop();
  }

  var docBound = false;

  function bindDocument() {
    if (docBound) return;
    docBound = true;

    document.addEventListener('click', function (e) {
      if (mq.matches) return;
      if (e.target.closest('.store-map-locations__popup')) return;
      if (e.target.closest('.store-map-locations__marker')) return;
      if (e.target.hasAttribute('data-store-map-backdrop')) {
        closeAllSections();
        return;
      }
    });
  }

  function init(root) {
    var wraps = root.querySelectorAll('.store-map-locations__marker-wrap');
    if (!wraps.length) return;

    bindDocument();

    wraps.forEach(function (wrap) {
      var btn = wrap.querySelector('.store-map-locations__marker');
      if (!btn) return;

      btn.addEventListener('click', function (e) {
        if (mq.matches) return;
        e.preventDefault();
        var willOpen = !wrap.classList.contains('is-open');
        closeAllSections();
        if (willOpen) {
          wrap.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          showBackdrop(root);
        }
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-store-map-locations]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
